import React, { useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from 'moment'
import BColor from '../BColor'

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.background.default,
        // },
    },
}))(TableRow);

function createData(ymd, cuser, cuper, cincp, cstock, csper, csincp) {
    return {ymd, cuser, cuper, cincp, cstock, csper, csincp };
}


const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 250,
      backgroundColor: theme.palette.type === "light" ? "#FFFFFF" : "#000000"
    },
    button1: {
      minWidth: 110,
    }
  }));

export default function BigSmallList1(props) {
    const classes = useStyles();
    const [buyselldata, setBuyselldata] = React.useState([]);

    useEffect(() => {
        if(props.open) fectchStockData(props.stockId)
    }, [props.stockId]);


    function fectchStockData(stockId) {
        if(stockId != null) {
            let a = {
                sid: stockId,
                inp: {}
            };
            
            if(localStorage.getItem('lms') != null && localStorage.getItem('lms') != 12)
                a.inp["lms"] = parseInt(localStorage.getItem('lms'))
            if(localStorage.getItem('sms') != null && localStorage.getItem('sms') != 8)
                a.inp["sms"] = parseInt(localStorage.getItem('sms'))


            fetch("/jstock/v1/stock/bigsmall", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        let dd = result.r.map(row =>
                            createData(moment(row.ymd, "YYYYMMDD").format('YYYY/MM/DD'), row.cuser, row.cuper, row.cincp, row.cstock, row.csper, row.csincp)
                        )
                        setBuyselldata(dd)
                    },
                    error => {
                    }
                );
        }
    }


    function renderValue(value, unit) {
        let colorx = "#000205"
        let word = '持平'
        let vv = value

        if (value > 0) {
            colorx = BColor.upcolorbox
            word = '增加'
        } else if(value < 0) {
            colorx = BColor.downcolorbox
            word = '減少'
            vv = -value      
        } else {
            colorx = BColor.faircolor
            word = '持平'
        }
        {(value.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}
        return <Button size="small"  variant="outlined" style={{ minWidth: 110, color: colorx }} className={classes.button1}>{word}{vv}{unit}</Button>
    }

    return (
        <Dialog 
        fullWidth={true}
        maxWidth={'lg'}
         open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{props.stockName}({props.stockId})散戶表</DialogTitle>

            <DialogContent>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table" size="small">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>日期</StyledTableCell>
                                <StyledTableCell align="center">散戶人數</StyledTableCell>
                                <StyledTableCell align="center">佔全體股東</StyledTableCell>
                                <StyledTableCell align="center">人數增減</StyledTableCell>
                                <StyledTableCell align="center">股票張數</StyledTableCell>
                                <StyledTableCell align="center">持股比例</StyledTableCell>
                                <StyledTableCell align="center">本週持股增減</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {buyselldata.map(row => (
                                <StyledTableRow key={row.ymd}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.ymd}
                                    </StyledTableCell>

                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {(row.cuser.toString()).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")}人
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {(row.cuper).toFixed(2)}%
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue((row.cincp).toFixed(2), '%')}
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {(row.cstock/10000000).toFixed(2)}萬張
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {(row.csper).toFixed(2)}%
                                    </StyledTableCell>
                                    <StyledTableCell style={{ whiteSpace: 'nowrap'}} align="center">
                                        {renderValue((row.csincp).toFixed(2), '%')}
                                    </StyledTableCell>

                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                {/* <Button onClick={props.handleClose} color="primary">
                    取消
          </Button> */}
                <Button onClick={props.handleClose} color="primary">
                    關閉
          </Button>
            </DialogActions>
        </Dialog>
    );
}
